import type { StaticPromptDefinition, StaticPromptProgress, StaticPromptSubmission } from "./types";

export function emptyDefinition(): StaticPromptDefinition {
  return {
    puzzleType: "static_prompt",
    typeVersion: 1,
    prompt: { blocks: [{ kind: "markdown", content: { fr: "", en: "" } }] },
    answer: {
      kind: "text",
      fields: [{ id: "main", label: { fr: "Réponse", en: "Answer" }, placeholder: null }],
      normalize: ["trim", "collapse_spaces", "casefold", "strip_accents", "strip_punctuation"],
      match: "any_of",
      checkStrategy: "stored_compare",
    },
    rulesText: { fr: "", en: "" },
  };
}

export function emptyProgress(_definition: StaticPromptDefinition): StaticPromptProgress {
  return { version: 1, fields: {} };
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

/** Accepts any stored blob (older versions, null, garbage) and returns a valid progress. */
export function migrateProgress(
  definition: StaticPromptDefinition,
  raw: unknown,
): StaticPromptProgress {
  if (!isRecord(raw)) return emptyProgress(definition);
  const source = isRecord(raw.fields) ? raw.fields : {};
  const fields: Record<string, string> = {};
  for (const [key, value] of Object.entries(source)) {
    if (typeof value === "string") fields[key] = value;
    else if (typeof value === "number" && Number.isFinite(value)) fields[key] = String(value);
  }
  return { version: 1, fields };
}

/** Every declared field is present, as a string: the server normalises, not the client. */
export function serializeSubmission(
  definition: StaticPromptDefinition,
  progress: StaticPromptProgress,
): StaticPromptSubmission {
  const fields: Record<string, string> = {};
  for (const field of definition.answer.fields ?? []) {
    fields[field.id] = progress.fields[field.id] ?? "";
  }
  return { fields };
}
